import supabase from './supabase';

// Types: 'post_like' | 'post_comment' | 'follow' | 'route_invite'

export async function sendNotification({ recipientId, actorId, type, postId = null, commentId = null, routeId = null, payload = {} }) {
  if (!recipientId || !actorId || !type) return null;
  if (recipientId === actorId) return null; // do not notify self
  try {
    const { data, error } = await supabase
      .from('notifications')
      .insert([{
        recipient_id: recipientId,
        actor_id: actorId,
        type,
        post_id: postId,
        comment_id: commentId,
        route_id: routeId,
        payload
      }])
      .select('*')
      .single();
    if (error) throw error;
    return data;
  } catch (err) {
    console.warn('[notify] sendNotification failed', err);
    return null; // non-fatal
  }
}

export async function fetchNotifications(limit = 20) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return [];
    const { data, error } = await supabase
      .from('notifications')
      .select('*')
      .eq('recipient_id', user.id)
      .order('created_at', { ascending: false })
      .limit(limit);
    if (error) throw error;
    return data || [];
  } catch (err) {
    console.warn('[notify] fetchNotifications failed', err);
    return [];
  }
}

export async function markNotificationRead(id) {
  try {
    const { error } = await supabase
      .from('notifications')
      .update({ read_at: new Date().toISOString() })
      .eq('id', id);
    if (error) throw error;
    return true;
  } catch (err) {
    console.warn('[notify] markNotificationRead failed', err);
    return false;
  }
}

export async function markAllNotificationsRead() {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return false;
    const { error } = await supabase
      .from('notifications')
      .update({ read_at: new Date().toISOString() })
      .is('read_at', null)
      .eq('recipient_id', user.id);
    if (error) throw error;
    return true;
  } catch (err) {
    console.warn('[notify] markAllNotificationsRead failed', err);
    return false;
  }
}

export function subscribeToNotifications(onInsert) {
  let channel = null;
  (async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      channel = supabase
        .channel('notifications-feed')
        .on('postgres_changes', {
          event: 'INSERT',
          schema: 'public',
          table: 'notifications',
          filter: `recipient_id=eq.${user.id}`
        }, (payload) => {
          if (typeof onInsert === 'function') onInsert(payload.new);
        })
        .subscribe();
    } catch (_) {}
  })();
  return () => {
    try { if (channel) supabase.removeChannel(channel); } catch (_) {}
  };
}

export function formatNotification(n, actorsById = {}) {
  const actor = actorsById[n.actor_id];
  const who = actor?.username || 'Someone';
  switch (n.type) {
    case 'post_like':
      return `${who} liked your post`;
    case 'post_comment':
      return `${who} commented on your post`;
    case 'follow':
      return `${who} started following you`;
    case 'route_invite':
      return `${who} invited you to collaborate on a route`;
    default:
      return 'You have a new notification';
  }
}

